import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

import BaseBlockContent from '@sanity/block-content-to-react'
import Layout from '../components/layout'
import SEO from '../components/seo'
import serializers from '../components/splash-page-serializers'

const IndexPage = () => {
  const { index } = useStaticQuery(graphql`
    {
      index: sanitySplashPage(_id: { eq: "index" }) {
        _rawSplashText
        _rawBody
        title
        splashImage {
          asset {
            fluid(maxWidth: 3840) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title={index.title} lang="en" description={index.description} />
      <section className="section section-feature page-heading">
        <div
          className="page-heading-splash-image"
          style={{ zIndex: -100, position: 'absolute' }}
        >
          {index.splashImage && <Img fluid={index.splashImage.asset.fluid} />}
        </div>
        <div className="splash-video-wrapper">
          <video playsInline autoPlay muted loop>
            <source src="https://healing-waters.s3.us-east-2.amazonaws.com/birds+eye+coast.mp4" />
          </video>
        </div>
        <div className="content">
          <BaseBlockContent
            blocks={index._rawSplashText}
            projectId={process.env.GATSBY_SANITY_PROJECT_ID}
            dataset={process.env.GATSBY_SANITY_DATASET}
          />
        </div>
      </section>
      <BaseBlockContent
        blocks={index._rawBody}
        serializers={serializers}
        projectId={process.env.GATSBY_SANITY_PROJECT_ID}
        dataset={process.env.GATSBY_SANITY_DATASET}
      />
    </Layout>
  )
}

export default IndexPage
